import { graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React, { type FC } from 'react'

export const CardHeader: FC<{
  asset: Queries.ContentfulWrapperRichMediaFragment['thumbnail']
}> = ({ asset }) => {
  if (!asset) return null
  return (
    <div className="bg-grey-100 py-5">
      <div className="m-auto h-[10rem] w-[10rem] overflow-hidden rounded-md shadow-[0_5px_10px_0px_rgba(0,0,0,0.25)]">
        <GatsbyImage alt={asset.description} image={getImage(asset)} />
      </div>
    </div>
  )
}

export const query = graphql`
  fragment ContentfulWrapperRichMediaThumbnail on ContentfulAsset {
    description
    gatsbyImageData(aspectRatio: 1, width: 160, formats: [AVIF, WEBP, AUTO])
  }
`
